export default __webpack_public_path__ + "static/media/logo-v2.9acae7ea.svg";